import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UpdateRegistrationAddress1Page } from './update-registration-address1';

import { IonicSelectableModule } from 'ionic-selectable';
import { BrMaskerModule } from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    UpdateRegistrationAddress1Page,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationAddress1Page),
    IonicSelectableModule,
    BrMaskerModule,
  ],
  exports: [
    UpdateRegistrationAddress1Page
  ]
})
export class UpdateRegistrationAddress1PageModule { }



// WEBPACK FOOTER //
// ./src/pages/update-registration-address1/update-registration-address1.module.ts